module.exports = __webpack_public_path__ + "static/wix-engineering.feee28e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/wix-engineering.png
// module id = 774
// module chunks = 40349708705702